module.exports = __webpack_public_path__ + "static/media/appqr.56f5e28b.png";